<template>
  <v-card class="mb-2">
    <v-toolbar dense flat dark color="primary">
      <v-toolbar-title>{{ testTypeTitle }} A/B Testing</v-toolbar-title>
      <v-spacer/>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon v-if="!value.started_at" @click="deregisterTest"><v-icon>mdi-delete</v-icon></v-btn>
        </template>
        <span>Cancel Split Test</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            v-if="value.started_at"
            @click.stop="completeTestDialogVisible = !completeTestDialogVisible">
              <v-icon>{{ startFinisheTestingIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ startFinishTestingMessage }}</span>
      </v-tooltip>
    </v-toolbar>
    <!-- show status of running or not running -->
    <v-alert dense type="warning" v-if="!value.started_at">
      Split Testing has not been started. Save and Schedule to start.
    </v-alert>
    <v-alert dense type="success" v-if="value.started_at">
      Split Testing Started on {{ value.started_at | usDateTime }}
    </v-alert>
    <v-alert dark color="secondary" icon="mdi-chart-line" v-if="value.started_at">
      <p><strong>Google Analytics Stats</strong> via <code>UTM Content</code></p>
      <v-spacer/>
      <p class="d-inline">
        <strong>Sendgrid Stats</strong>
        <ol>
          <li><v-btn text x-small @click.prevent="copy('ABTEST-' + value.id  + '-')">Copy Sendgrid Search Filter</v-btn></li>
          <li><v-btn text x-small @click.prevent="openSendgrid">Search Sendgrid</v-btn></li>
        </ol>
      </p>
    </v-alert>

    <v-card-text>
        <!-- A -->
      <v-row>
        <v-col md="4" offset-md="2">
          <v-card>
            <v-toolbar color="primary" dark dense>
              <v-toolbar-title>{{ testTypeTitle }} [Variant A]</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <!-- Subject Variant A -->
              <v-text-field
                v-if="isSubjectType"
                :value="value.variant_a"
                @input="updateStringModel('variant_a', $event)"
                :label="testTypeTitle"
                :placeholder="testTypeTitle"
                outlined
                required
                v-validate="'required'"
                data-vv-name="variant_a"
                :error-messages="errors.collect('variant_a')"
              >
              </v-text-field>

              <v-text-field
                v-if="isSubjectType"
                v-model="variantAPreHeader"
                label="PreHeader"
                placeholder="PreHeader"
                outlined
              >
              </v-text-field>

              <!-- Email Sender Variant A-->
              <email-sender-select
                v-if="isSenderType"
                :value="parseInt(value.variant_a)"
                :dealer_id="emailCampaign.dealer_id"
                :rooftop_id="emailCampaign.dealer_rooftop_id"
                @input="updateStringModel('variant_a', parseInt($event))"
                v-validate="'required'"
                data-vv-name="variant_a"
                :error-messages="errors.collect('variant_a')"
                required
              />

              <!-- Email Template Select Variant A -->
              <template v-if="isContentType">
                <email-template-select
                  v-model="value.variant_a"
                  v-on:selected-email-template="updateObjectModel('variant_a', $event)"
                  :dealer_id="emailCampaign.dealer_id"
                  :email_template_id="parseInt(value.variant_a)"
                  v-validate="'required'"
                  data-vv-name="variant_a"
                  :error-messages="errors.collect('variant_a')"
                  :show-preview="true"
                  required
                />

                <mapping-dialog
                  ref="contentMappingA"
                  v-model="variantAContentMapping"
                  :datasource="datasource"
                  :email-template="variantAObject"
                  lhs-title="Email Template Field"
                  rhs-title="DataSource Field"
                  default-value-title="Fallback Value"
                />

              </template>

              <!-- Time Variant A -->
              <ampm-time-picker
                v-if="isTimeType"
                v-model="value.variant_a"
                v-validate="'required'"
                data-vv-name="variant_a"
                :error-messages="errors.collect('variant_a')"
                label="Execute At"
                :allowed-interval-minutes="15"
                @change="updateStringModel('variant_a', $event)"
              />

               <h2>{{ percentageA }}%</h2>
            </v-card-text>
            <v-card-actions class="justify-center" v-if="completeTestDialogVisible">
               <v-btn class="blue--text text--darken-2" @click="promoteVariantA">Winner! Promote Variant A</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- B -->
        <v-col md="4">
          <v-card>
            <v-toolbar color="primary" dark dense>
              <v-toolbar-title>{{ testTypeTitle }} [Variant B]</v-toolbar-title>
            </v-toolbar>
            <v-card-text>

              <!-- Subject Variant B -->
              <v-text-field
                v-if="isSubjectType"
                :value="value.variant_b"
                @input="updateStringModel('variant_b', $event)"
                :label="testTypeTitle"
                :placeholder="testTypeTitle"
                outlined
                required
                v-validate="'required'"
                data-vv-name="variant_b"
                :error-messages="errors.collect('variant_b')"
              >
              </v-text-field>

              <v-text-field
                v-if="isSubjectType"
                v-model="variantBPreHeader"
                label="PreHeader"
                placeholder="PreHeader"
                outlined
              >
              </v-text-field>

              <!-- Email Sender Variant B -->
              <email-sender-select
                v-if="isSenderType"
                :value="parseInt(value.variant_b)"
                :dealer_id="emailCampaign.dealer_id"
                :rooftop_id="emailCampaign.dealer_rooftop_id"
                @input="updateStringModel('variant_b', parseInt($event))"
                v-validate="'required'"
                data-vv-name="variant_b"
                :error-messages="errors.collect('variant_b')"
                required
              />

              <!-- Email Template Select Variant B -->
              <template v-if="isContentType">
                <email-template-select
                  v-model="value.variant_b"
                  v-on:selected-email-template="updateObjectModel('variant_b', $event)"
                  :dealer_id="emailCampaign.dealer_id"
                  :email_template_id="parseInt(value.variant_b)"
                  v-validate="'required'"
                  data-vv-name="variant_b"
                  :error-messages="errors.collect('variant_b')"
                  :show-preview="true"
                  required
                />
                  <!-- TODO error message is incorrect value -->
                <mapping-dialog
                  ref="contentMappingB"
                  v-model="variantBContentMapping"
                  :datasource="datasource"
                  :email-template="variantBObject"
                  lhs-title="Email Template Field"
                  rhs-title="DataSource Field"
                  default-value-title="Fallback Value"
                />

              </template>

              <!-- Time Variant B -->
              <ampm-time-picker
                v-if="isTimeType"
                v-model="value.variant_b"
                v-validate="'required'"
                data-vv-name="variant_b"
                :error-messages="errors.collect('variant_b')"
                label="Execute At"
                :allowed-interval-minutes="15"
                @change="updateStringModel('variant_b', $event)"
              />

               <h2>{{ percentageB }}%</h2>
               <v-spacer/>
            </v-card-text>
            <v-card-actions class="justify-center" v-if="completeTestDialogVisible">
               <v-btn class="green--text text--darken-2" @click="promoteVariantB">Winner! Promote Variant B</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="8" offset="2">
          <v-slider
            :value="value.split_percentage"
            @input="updateStringModel('split_percentage', $event)"
            min="0"
            max="100"
            track-color="green"
            thumb-color="red"
            hint="A/B Percentage Split"
            persistent-hint
          >
          </v-slider>
        </v-col>
      </v-row>

   </v-card-text>
    <!-- Overlay for Saves -->
    <v-overlay :value="isSaving">
      <div class="text-center">
        <h2 class="mb-6">Finalizing Split Test - Updating Campaign</h2>
        <v-progress-circular indeterminate size="72"></v-progress-circular>
      </div>
    </v-overlay>
  </v-card>
</template>

<script>
import {
  EmailTemplateSelect,
  AmPmTimePicker,
  EmailSenderSelect
} from '@/components/inputs'

import { EmailCampaignApi, EmailTemplateApi } from '@/services'

import Titleize from '../../filters/titleize'
import validationMixin from '@/validators/validations_mixin'
import { CopyTextMixin } from '@/components/mixins'
import MappingDialog from './MappingDialog'
import * as R from 'ramda'

export default {
  name: 'split-test-edit',
  mixins: [validationMixin, CopyTextMixin],
  components: {
    [EmailTemplateSelect.name]: EmailTemplateSelect,
    [EmailSenderSelect.name]: EmailSenderSelect,
    [AmPmTimePicker.name]: AmPmTimePicker,
    [MappingDialog.name]: MappingDialog
  },
  inject: ['$validator'],
  props: {
    value: {
      required: true,
      type: Object
    },
    emailCampaign: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      completeTestDialogVisible: false,
      variantAObject: {},
      variantBObject: {},
      isSaving: false
    }
  },
  computed: {
    testTypeTitle: function () {
      return Titleize.titleize(this.value.test_type)
    },
    isSubjectType: function () { return this.value.test_type === 'subject' },
    isSenderType: function () { return this.value.test_type === 'sender' },
    isContentType: function () { return this.value.test_type === 'content' },
    isTimeType: function () { return this.value.test_type === 'time' },
    percentageA: function () {
      return parseInt(this.value.split_percentage)
    },
    percentageB: function () {
      return 100 - parseInt(this.value.split_percentage)
    },
    // used for common template A vs B Mapping
    datasource: function () {
      return this.emailCampaign.datasource
    },
    variantAContentMapping: {
      get () {
        if (this.isContentType) {
          return R.pathOr([], ['meta', 'variant_a_mapping'], this.value)
        } else {
          return null
        }
      },
      set (mapping) {
        if (this.isContentType) {
          const meta = this.value.meta || {}
          meta.variant_a_mapping = mapping
          this.$set(this.value, 'meta', meta)
        }
      }
    },
    variantBContentMapping: {
      get () {
        if (this.isContentType) {
          return R.pathOr([], ['meta', 'variant_b_mapping'], this.value)
        } else {
          return null
        }
      },
      set (mapping) {
        if (this.isContentType) {
          const meta = this.value.meta || {}
          meta.variant_b_mapping = mapping
          this.$set(this.value, 'meta', meta)
        }
      }
    },
    variantAPreHeader: {
      get () {
        if (this.isSubjectType) {
          return R.pathOr('', ['meta', 'variant_a_preheader'], this.value)
        } else {
          return null
        }
      },
      set (preheader) {
        if (this.isSubjectType) {
          const meta = this.value.meta || {}
          meta.variant_a_preheader = preheader
          this.$set(this.value, 'meta', meta)
        }
      }
    },
    variantBPreHeader: {
      get () {
        if (this.isSubjectType) {
          return R.pathOr('', ['meta', 'variant_b_preheader'], this.value)
        } else {
          return null
        }
      },
      set (preheader) {
        if (this.isSubjectType) {
          const meta = this.value.meta || {}
          meta.variant_b_preheader = preheader
          this.$set(this.value, 'meta', meta)
        }
      }
    },
    startFinishTestingMessage () {
      if (this.completeTestDialogVisible) {
        return 'Cancel Complete Testing'
      } else {
        return 'Complete Testing'
      }
    },
    startFinisheTestingIcon () {
      if (this.completeTestDialogVisible) {
        return 'mdi-undo'
      } else {
        return 'mdi-stop-circle'
      }
    }

  },
  watch: {
    'value.variant_a': {
      immediate: true,
      handler (newVal) {
        // we know it's loaded if they hit here
        if (this.isContentType) {
          this.loadEmailTemplate('variant_a', newVal)
        }
      }
    },
    'value.variant_b': {
      immediate: true,
      handler (newVal) {
        // we know it's loaded if they hit here
        if (this.isContentType) {
          this.loadEmailTemplate('variant_b', newVal)
        }
      }
    }
  },
  methods: {
    updateStringModel (key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    updateObjectModel (key, value) {
      // object model always looks to set the ID as int
      this.$emit('input', { ...this.value, [key]: parseInt(value.id) })
    },
    deregisterTest () {
      EmailCampaignApi.deleteSplitTest(this.emailCampaign.id, this.value.id)
        .then(() => {
          this.$emit('split-test-deleted')
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: `Error deleting Split Test. ${error.message}`,
            type: 'error',
            duration: 0
          })
        })
    },
    promoteVariantA () {
      return this.completeTest('variant_a')
    },
    promoteVariantB () {
      return this.completeTest('variant_b')
    },
    completeTest (variantWinner) {
      this.isSaving = true
      EmailCampaignApi.promoteSplitTestWinner(this.emailCampaign.id, this.value.id, variantWinner)
        .then(() => {
          this.isSaving = false
          this.$emit('split-test-complete')
          this.$flash({
            showClose: true,
            message: 'Campaign has been updated with Split Test Winning Results!',
            type: 'success',
            duration: 0
          })
        })
        .catch(error => {
          this.isSaving = false
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: `Error Completing Split Test. ${error.message}`,
            type: 'error',
            duration: 0
          })
        })
    },
    openSendgrid () {
      window.open('https://app.sendgrid.com/statistics/category/compare', '_blank')
    },
    loadEmailTemplate (variantName, templateId) {
      if (R.isNil(templateId)) {
        return
      }
      EmailTemplateApi.getEmailTemplate(parseInt(templateId))
        .then(et => {
          if (variantName === 'variant_a') {
            this.variantAObject = et.data
          } else {
            this.variantBObject = et.data
          }
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: `Error loading templates for variants. ${error.message}`,
            type: 'mini',
            duration: 0
          })
        })
    },
    validateMapping () {
      if (this.isContentType) {
        const va = this.$refs.contentMappingA.isMappingValid()
        const vb = this.$refs.contentMappingB.isMappingValid()
        return va && vb
      } else {
        return true
      }
    }
  }
}
</script>
